import type { MruCache } from 'owa-mru-cache';
import type FreeBusyRow from '../schema/FreeBusyRow';

const attendeeMruCache: {
    [id: string]: MruCache<FreeBusyRow>;
} = {};

export function getMruCache(): {
    [id: string]: MruCache<FreeBusyRow>;
} {
    return attendeeMruCache;
}

export function getAttendeeMruCache(key: string): MruCache<FreeBusyRow> {
    return getMruCache()[key];
}
